import {MultiTargetRelation} from '../MultiTargetRelation';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import type {ISketchObject} from '../../../../../mesh/sketch';

let count = 0;

/**
 * 圆-曲线长度相等关系约束。
 */
export function isCircleCurveLengthEqualConstraint(value: object): value is CircleCurveLengthEqualConstraint {
    return Reflect.get(value, "isCircleCurveLengthEqualConstraint") === true;
}
export class CircleCurveLengthEqualConstraint extends MultiTargetRelation<ISketchObject> {
    readonly isCircleCurveLengthEqualConstraint: boolean = true;
    /**
     * 关系类型。
     */
    public relationType = SketchRelationKind.EqualCurveLength;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    public get baseDisplayName(): string {
        return '曲线长度相等';
    }

}
